import Singleton from './singleton'

export default class IconService extends Singleton {
  constructor (singleton, path) {
    super(singleton)

    if (typeof path !== 'string') {
      throw new TypeError(`Base uri has to be string. Typeof ${typeof path} given.`)
    }

    this.path = path
  }

  get resolver () {
    return (name, ext = 'svg') => {
      return `${this.path}/icons/${name}.${ext}`
    }
  }
}
